document.addEventListener('DOMContentLoaded',function(){
  var fontButton=Array.from(document.querySelectorAll('.font-choice')).find(function(button){
    var name=button.querySelector('small');
    return name&&name.textContent.trim()==='Dekor 36';
  });
  if(fontButton){
    fontButton.click();
    var fontGrid=fontButton.closest('.font-picker');
    if(fontGrid)fontGrid.scrollTop=Math.max(0,fontButton.offsetTop-fontGrid.offsetTop-8);
  }else{
    var fontSelect=document.querySelector('[data-font]');
    if(fontSelect){
      fontSelect.value='Dekor 36';
      fontSelect.dispatchEvent(new Event('change',{bubbles:true}));
    }
  }

  var wantedBand=location.pathname.includes('thermosatin-100-mm-bedruckt')?'Creme 158':'Creme 245';
  var bandButton=Array.from(document.querySelectorAll('[data-swatches] .swatch')).find(function(button){return button.dataset.name===wantedBand});
  if(bandButton)bandButton.click();

  var printButton=Array.from(document.querySelectorAll('.print-choice')).find(function(button){return button.title==='Bordeaux'});
  if(printButton)printButton.click();
  else{
    var printSelect=document.querySelector('[data-print]');
    if(printSelect){
      printSelect.value='Bordeaux';
      printSelect.dispatchEvent(new Event('change',{bubbles:true}));
    }
    
  }document.querySelectorAll('[data-swatches] .swatch').forEach(function(button){
  button.addEventListener('click', function(){
    document.querySelectorAll('[data-swatches] .swatch.is-tooltip-open').forEach(function(other){
      if(other !== button) other.classList.remove('is-tooltip-open');
    });

    button.classList.add('is-tooltip-open');
  });
});
});
